import ViewManager from "../utils/ViewManager";
import { DefaultLayers } from "../utils/Layers";
import BitmapTextField from "../views/components/BitmapTextField";
import TextField from "../views/components/TextField";
import GameModel from "../model/GameModel";
import { Text } from "pixi.js";

/**
 * Adds a clock to the game. Requires an 'Header' layer with default scene at the psd.
 *
 * @export
 * @class ClockController
 */
export default class ClockController {
    private clockField: Text | BitmapTextField | TextField | undefined;
    private clockInterval: NodeJS.Timeout;

    /**
     * Creates an instance of ClockController.
     * @memberof ClockController
     */
    constructor() {
        const layer = ViewManager.getLayer(DefaultLayers.Header);
        const clockScene = layer.setScene();
        if (!GameModel.clock) {
            layer.completeClear();
            return;
        }

        this.clockField = clockScene.sceneTextFields.get("clock");
        this.updateTime();
        this.clockInterval = setInterval(() => {
            this.updateTime();
        }, 1000);
    }

    /**
     * Stops the time update loop.
     *
     * @memberof ClockController
     */
    public stopClockUpdate() {
        if (this.clockInterval) {
            clearInterval(this.clockInterval);
        }
    }

    /**
     * Updates the time.
     *
     * @memberof ClockController
     */
    private updateTime() {
        if (!this.clockField) {
            return;
        }

        let date = new Date();
        let hours = date.getHours();
        let minutes = date.getMinutes();
        if (minutes < 10) {
            this.clockField.text = hours + ":0" + minutes;
        } else {
            this.clockField.text = hours + ":" + minutes;
        }
    }
}
